<mat-tab-group class="hideTabHeader" *ngIf="true" (selectedIndexChange)="onTabIndexChange($event)"
               [selectedIndex]="selectedFieldSectionIndex">
  <mat-tab *ngFor="let child of [{header:'1 page'},{header:'2 page'},{header:'3 page'}]; let i = index">
    <ng-template mat-tab-label>
      <div class="custom-tab-header flex flex-row justify-start items-center">
        <div class="flex flex-col justify-start items-center">
          <div>{{child.header}}</div>
        </div>
      </div>
    </ng-template>
    <!-- REMOVE IT FOR BELOW DEV p-30-->

    <!--NOTE TAB ARE
    VERTICAL HERE SO
    NO NEED PADDING-->

    <div *ngIf="selectedFieldSectionIndex == i" class="form-container flex flex-col">
      <particle-flow-chart-designer [section]="section" [sourceType]="sourceType"
                                    [flowChartDataService]="flowChartDataService"></particle-flow-chart-designer>
    </div>
  </mat-tab>

</mat-tab-group>
<mat-paginator [length]="0"
               [pageSize]="1"
               (page)="onPageChange($event)"
>
</mat-paginator>
